import React, { useCallback } from "react";
import classNames, { Argument } from "classnames/dedupe";
import { ValueOf } from "../../../../helpers";
import { TThemeVariant, useTheme } from "../../../Utility/ThemeProvider";
import { FormCheckWrapper } from "../../../Atoms/FormLabel";
import { Checkbox } from "../../Checkbox";
import FilterFormItemWrapper from "../../../Navigational/Filters/FilterFormItemWrapper/FilterFormItemWrapper";
import { IDropdownOptionProps } from "../DropdownOption";

export interface ICheckboxDropdownOptionProps<Option>
  extends IDropdownOptionProps<Option> {
  item: Option;
  labelKey: keyof Option;
  valueKey: keyof Option;
  variant?: TThemeVariant;
  showCounter?: boolean;
  // type?: "default" | "checkbox";
  // titlePrefix?: ReactNode;
  classes?: {
    root?: Argument;
  };
  disabled?: boolean;
  selected?: boolean;
  onSelect?: (value: ValueOf<Option>) => void;
}

export interface ICounterOption {
  itemsCount: number;
}

function CheckboxOption<Option>({
  item,
  labelKey,
  valueKey,
  classes,
  variant,
  selected,
  disabled,
  showCounter = true,
  onSelect,
}: ICheckboxDropdownOptionProps<Option>): JSX.Element {
  const theme = useTheme(variant);
  const handleChange = useCallback(() => {
    onSelect && onSelect(item[valueKey]);
  }, [item, onSelect, valueKey]);
  return (
    <FilterFormItemWrapper type="checkbox">
      <FormCheckWrapper isFilterRow variant="dark" tag="label">
        <div
          className={classNames("d-flex align-items-center", classes?.root)}
          data-testid="CheckboxOption"
        >
          {showCounter ? (
            <div
              className={classNames("me-4 form-check-label__total", {
                "text-color-blue": theme === "dark",
              })}
            >
              {(item as Option & ICounterOption).itemsCount}
            </div>
          ) : null}
          <Checkbox
            name={valueKey as string}
            variant={theme === "dark" ? "light" : "dark"}
            checked={selected}
            disabled={disabled}
            onChange={handleChange}
          />
        </div>
        <div
          className={classNames("form-check-label__name", {
            "text-color-blue": theme === "dark",
          })}
        >
          {item[labelKey] as string}
        </div>
      </FormCheckWrapper>
    </FilterFormItemWrapper>
  );
}

export default CheckboxOption;
